<script setup lang="ts">
import { defineProps } from 'vue'
import TimeRemainingBadge from '@/components/common/feedback/TimeRemainingBadge.vue'

defineProps(['params'])
</script>

<template>
  <time-remaining-badge :deadline="params?.data?.dateDeadline" :with-date="true" />
</template>
